module.exports = __WEBPACK_EXTERNAL_MODULE_angular_ui_router__;